"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncomeSubcategories = exports.TransferSubcategories = exports.TaxSubcategories = exports.PersonalDeductionsSubcategories = exports.VehiclesMachineryEquipmentSubcategories = exports.CarExpensesSubcategories = exports.TravelTransportSubcategories = exports.HomeExpensesSubcategories = void 0;
var HomeExpensesSubcategories;
(function (HomeExpensesSubcategories) {
    HomeExpensesSubcategories["HomeRentalInsurance"] = "Home & Rental Insurance";
    HomeExpensesSubcategories["Rent"] = "Rent";
    HomeExpensesSubcategories["WifiBill"] = "WiFi Bill";
    HomeExpensesSubcategories["HomeOfficeRepairsMaintenance"] = "Home Office Repairs & Maintenance";
    HomeExpensesSubcategories["PropertyTax"] = "Property Tax";
    HomeExpensesSubcategories["Utilities"] = "Utilities";
})(HomeExpensesSubcategories = exports.HomeExpensesSubcategories || (exports.HomeExpensesSubcategories = {}));
var TravelTransportSubcategories;
(function (TravelTransportSubcategories) {
    TravelTransportSubcategories["PublicTransport"] = "Public Transport";
    TravelTransportSubcategories["TravelLodging"] = "Travel Lodging";
    TravelTransportSubcategories["Flight"] = "Flight";
})(TravelTransportSubcategories = exports.TravelTransportSubcategories || (exports.TravelTransportSubcategories = {}));
var CarExpensesSubcategories;
(function (CarExpensesSubcategories) {
    CarExpensesSubcategories["Gas"] = "Gas";
    CarExpensesSubcategories["CarMaintenance"] = "Car Maintenance";
    CarExpensesSubcategories["CarWash"] = "Car Wash";
    CarExpensesSubcategories["TollFee"] = "Toll Fee";
    CarExpensesSubcategories["Parking"] = "Parking";
    CarExpensesSubcategories["CarInsurance"] = "Car Insurance";
    CarExpensesSubcategories["CarLease"] = "Car Lease";
})(CarExpensesSubcategories = exports.CarExpensesSubcategories || (exports.CarExpensesSubcategories = {}));
var VehiclesMachineryEquipmentSubcategories;
(function (VehiclesMachineryEquipmentSubcategories) {
    VehiclesMachineryEquipmentSubcategories["Gas"] = "Car Payment";
})(VehiclesMachineryEquipmentSubcategories = exports.VehiclesMachineryEquipmentSubcategories || (exports.VehiclesMachineryEquipmentSubcategories = {}));
var PersonalDeductionsSubcategories;
(function (PersonalDeductionsSubcategories) {
    PersonalDeductionsSubcategories["MedicalInsurance"] = "Medical Insurance";
    PersonalDeductionsSubcategories["MedicalExpenses"] = "Medical Expense";
    PersonalDeductionsSubcategories["HSAContributions"] = "HSA Contribution";
    PersonalDeductionsSubcategories["RetirementContribution"] = "Retirement Contribution";
    PersonalDeductionsSubcategories["CharitableContribution"] = "Charitable Contribution";
})(PersonalDeductionsSubcategories = exports.PersonalDeductionsSubcategories || (exports.PersonalDeductionsSubcategories = {}));
var TaxSubcategories;
(function (TaxSubcategories) {
    TaxSubcategories["TaxPayment"] = "Tax Payment";
    TaxSubcategories["PayrollTax"] = "Payroll Tax";
    TaxSubcategories["WithholdingDeposit"] = "Withholding Deposit";
    TaxSubcategories["WithholdingWithdraw"] = "Withholding Withdraw";
})(TaxSubcategories = exports.TaxSubcategories || (exports.TaxSubcategories = {}));
var TransferSubcategories;
(function (TransferSubcategories) {
    TransferSubcategories["InternalTransfer"] = "Internal Transfer";
    TransferSubcategories["CreditCardPayment"] = "Credit Card Payment";
    TransferSubcategories["OwnersDeposit"] = "Owner's Deposit";
    TransferSubcategories["OwnersWithdraw"] = "Owner's Withdraw";
})(TransferSubcategories = exports.TransferSubcategories || (exports.TransferSubcategories = {}));
var IncomeSubcategories;
(function (IncomeSubcategories) {
    IncomeSubcategories["Income1099"] = "1099";
})(IncomeSubcategories = exports.IncomeSubcategories || (exports.IncomeSubcategories = {}));
//# sourceMappingURL=subcategories.js.map